export default "__VITE_ASSET__BpdDHp$L__"